import script from "./ContextReverso.vue?vue&type=script&setup=true&lang=js"
export * from "./ContextReverso.vue?vue&type=script&setup=true&lang=js"

import "./ContextReverso.vue?vue&type=style&index=0&id=1684b5c1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1684b5c1"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard});
